let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class ProductNotFoundService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.SessionService = SessionService;
  }
  
  mailProductNotFound(data){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.mailProductNotFound,
        cache : true,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data : this.$httpParamSerializerJQLike(data)
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }
  
}

ProductNotFoundService.$inject = inject;

export default ProductNotFoundService;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/product-not-found/product-not-found.service.js
 **/